export default function Footer() {
  return (
    <>
      <footer className="max-w-[1280px] m-auto px-4 md:px-0 text-textColor">
        <p className="max-w-[568px] m-auto pb-12 text-center">Pomodoro</p>
      </footer>
    </>
  )
}
